import React, { useState, useEffect, useRef } from 'react';
import { Dimensions, Platform, TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { QuickActionMenu, VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  getThemeImages,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { usePrevious } from '@vfgroup-oneplatform/foundation/Utils/Hooks';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import FrameworkTestKeys from '../FrameworkTestKeys';

import Payment from './Payment';
import styles from './PaymentWrapper.Styles';
import { PaymentScreenTypes, PaymentTypes } from './Utils/PaymentTypes';

import ReactNativeModal from 'react-native-modal'
import { View } from 'react-native';


const PaymentWrapper = ({
  isVisible,
  toggleModal,
  quickActionTitleAccessibilityLabel,
  quickActionCloseIconAccessibilityLabel,
  quickActionMainViewAccessibilityLabel,
  type,
  closeModal,
  username,
  defaultPayment,
  onClose,
  QATitle,
  QATitlePlaceholders,
  theme,
  withTopUpSomeOneElseTitle,
  userType,
  isAutoBillSetup,
  isAutoTopUpSetup,
  isPaymentMethod,
  isSelectRecipientPayGType,
  containerBackgroundColor,
  navigateToScreen,
  isCenterModal,
  ...props
}) => {
  const quickActionMenuRef = React.createRef();
  const scrollViewProps = useRef({ keyboardShouldPersistTaps: 'handled' });
  const prevVisable = usePrevious(isVisible);

  const [paymentOptions, setPaymentOptions] = useState({});

  useEffect(() => {
    !isVisible && setPaymentOptions({});
    if (prevVisable && !isVisible) {
      onClose && onClose();
    }
  }, [isVisible, prevVisable]);

  const onSelectedRecipientPress = () => {
    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: PaymentScreenTypes.TOP_UP_SOMEONE_ELSE,
      isTopupSomeoneElseTitleVisible: false,
      isBackButton: false,
      withCustomTabAmount: false,
    }));
  };

  const onBackButtonPress = () => {
    const screen =
      paymentOptions.screen === PaymentScreenTypes.TOP_UP_SOMEONE_ELSE_CONTACT_LIST
        ? PaymentScreenTypes.TOP_UP_SOMEONE_ELSE
        : null;

    const title = QATitle
      ? ContentManager.translate(QATitle, QATitlePlaceholders)
      : withTopUpSomeOneElseTitle
        ? 'top_up_someone_else_quick_action_title'
        : ContentManager.translate('top_up_quick_action_main_title', [username]);

    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: screen,
      title,
      isBackButton: false,
      isTopupSomeoneElseTitleVisible: !screen && type === PaymentTypes.TOP_UP_SOMEONE_ELSE,
    }));
  };

  const getQuickActionMenuTitle = () => {
    return paymentOptions.title
      ? paymentOptions.title
      : withTopUpSomeOneElseTitle
        ? 'top_up_someone_else_quick_action_title'
        : isAutoBillSetup
          ? 'auto_bill_quick_action_title'
          : isAutoTopUpSetup
            ? 'auto_top_up_quick_action_title'
            : QATitle
              ? ContentManager.translate(QATitle, QATitlePlaceholders)
              : ContentManager.translate('top_up_quick_action_main_title', [username]);
  };

  const renderTopUpSomeoneElseTitle = () => {
    return (
      withTopUpSomeOneElseTitle &&
      paymentOptions.isTopupSomeoneElseTitleVisible && (
        <TouchableOpacity
          style={styles.topupSomeoneElseTitleView}
          onPress={onSelectedRecipientPress}
        >
          <VFText
            i18nKey={paymentOptions.topupPhoneNumber || 'top_up_someone_else_quick_action_subtitle'}
            style={styles.topupSomeoneElseTitle}
            type="tertiary"
          />
        </TouchableOpacity>
      )
    );
  };

  const _images = getThemeImages(theme.name);
  if (isCenterModal) {
    return (
      <ReactNativeModal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onBackdropPress={() => toggleModal()}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '730px',
            maxWidth: '730px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          {props.children}
          <Payment
            toggleModal={toggleModal}
            type={paymentOptions.paymentType || type}
            defaultPayment={defaultPayment}
            setPaymentOptions={setPaymentOptions}
            paymentOptions={paymentOptions}
            closeModal={closeModal}
            theme={theme}
            userType={userType}
            navigateToScreen={navigateToScreen}
            isCenter={true}
            {...props}
          />
        </View>
      </ReactNativeModal>
    )
  }
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={{ paddingHorizontal: '10%', }}>
        {props.children}
        <Payment
          toggleModal={toggleModal}
          type={paymentOptions.paymentType || type}
          defaultPayment={defaultPayment}
          setPaymentOptions={setPaymentOptions}
          paymentOptions={paymentOptions}
          closeModal={closeModal}
          theme={theme}
          userType={userType}
          navigateToScreen={navigateToScreen}
          {...props}
        />
      </View>
    )
  }
  return (
    <QuickActionMenu
      title={getQuickActionMenuTitle()}
      isVisible={isVisible}
      toggleModal={toggleModal}
      closeModal={closeModal}
      type={paymentOptions.QAType || 'secondary'}
      accessibilityLabel={FrameworkTestKeys.QuickActionMainView}
      ref={quickActionMenuRef}
      TitleAccessibilityLabel={quickActionTitleAccessibilityLabel}
      closeIconAccessibilityLabel={quickActionCloseIconAccessibilityLabel}
      mainViewAccessibilityLabel={quickActionMainViewAccessibilityLabel}
      containerStyle={[styles.container, containerBackgroundColor]}
      titleStyle={styles.title(theme, withTopUpSomeOneElseTitle)}
      isBackButton={paymentOptions.isBackButton}
      onBackButtonPress={onBackButtonPress}
      backButtonIcon={_images.ic_arrow_left}
      renderCenterHeader={renderTopUpSomeoneElseTitle}
      scrollViewProps={scrollViewProps.current}
      closeBtnStyle={styles.closeBtnStyle(withTopUpSomeOneElseTitle)}
      backBtnStyle={styles.backBtnStyle(withTopUpSomeOneElseTitle)}
      withKeyboardAvoid
    >
      <Payment
        isPaymentMethod={isPaymentMethod}
        toggleModal={toggleModal}
        type={paymentOptions.paymentType || type}
        defaultPayment={defaultPayment}
        setPaymentOptions={setPaymentOptions}
        paymentOptions={paymentOptions}
        closeModal={closeModal}
        theme={theme}
        userType={userType}
        isSelectRecipientPayGType={isSelectRecipientPayGType}
        {...props}
      />
    </QuickActionMenu>
  );
};
PaymentWrapper.defaultProps = {
  theme: LightThemeColors,
  withTopUpSomeOneElseTitle: false,
  isPaymentMethod: true,
  getAdditionalTrackingInfo: () => { },
  isSelectRecipientPayGType: false,
  withCustomTab: true,
  isTopupSomeOneElseErrorSingleAction: false,
};
PaymentWrapper.propTypes = {
  isPaymentMethod: PropTypes.bool,
  isLoading: PropTypes.bool,
  username: PropTypes.string,
  defaultPayment: PropTypes.object,
  toggleModal: PropTypes.func,
  isVisible: PropTypes.bool,
  quickActionTitleAccessibilityLabel: PropTypes.string,
  quickActionCloseIconAccessibilityLabel: PropTypes.string,
  quickActionMainViewAccessibilityLabel: PropTypes.string,
  closeModal: PropTypes.func,
  type: PropTypes.string,
  onClose: PropTypes.func,
  QATitle: PropTypes.string,
  QATitlePlaceholders: PropTypes.array,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTopUpSomeOneElseTitle: PropTypes.bool,
  isTopUpSomeOne: PropTypes.bool,
  userType: PropTypes.oneOf(Object.values(User_Types)),
  isAutoBillSetup: PropTypes.bool,
  isAutoTopUpSetup: PropTypes.bool,
  getAdditionalTrackingInfo: PropTypes.func,
  isSelectRecipientPayGType: PropTypes.bool,
  withCustomTab: PropTypes.bool,
  isTopupSomeOneElseErrorSingleAction: PropTypes.bool,
  topupSomeOneElseErrorSingleActionStyle: ViewPropTypes.style,
  containerBackgroundColor: ViewPropTypes.style,
};

export default withTheme(PaymentWrapper);
